import router from "@/router"

/**
 * 函数防抖
 * @param callback 防抖函数
 * @param delay 防抖时间
 * @param isImmediately 是否立即执行
 */
const baseURL = process.env.VUE_APP_BASE_API

export const debounce = (callback, delay = 800, isImmediately = true) => {
  let timer = null
  return function () {
    // 保存this和arguments
    const that = this
    const args = arguments
    // 清除待执行的定时器任务
    if (timer) {
      clearTimeout(timer)
    }
    !timer && isImmediately && callback.apply(that, args)
    // 每隔delay的时间, 启动一个新的延迟定时器, 去准备调用callback
    timer = setTimeout(function () {
      timer = null
      !isImmediately && callback.apply(that, args)
    }, delay)
  }
}

// 函数节流
let isPending = false
export const throttle = (callback, delay = 2000) => {
  return function () {
    // 清除待执行的定时器任务
    if (isPending) return
    // 保存this和arguments
    const that = this
    const args = arguments
    //立即调用
    callback.apply(that, args)
    // 每隔delay的时间, 启动一个新的延迟定时器, 去准备调用callback
    isPending = setTimeout(function () {
      isPending = null
    }, delay)
  }
}

// 过滤请求参数
export const filterParams = (obj) => {
  if (!obj) {
    return {}
  }

  const newObj = JSON.parse(JSON.stringify(obj))

  for (let key in newObj) {
    if (newObj[key] === null) {
      delete newObj[key]
    }
    if (valueType(newObj[key]) === 'String') {
      newObj[key] = newObj[key].trim()
    } else if (valueType(newObj[key]) === 'Object') {
      newObj[key] = filterParams(newObj[key])
    }
    // else if (valueType(newObj[key]) === 'Array'){
    //   newObj[key] = pars(newObj[key])
    // }
  }
  return newObj
}

/**
 * 判断值类型
 * @param val
 * @returns {boolethrottlean}
 */
export const valueType = (val) => {
  const type = {
    '[object Object]': 'Object',
    '[object Array]': 'Array',
    '[object Undefined]': 'Undefined',
    '[object Null]': 'Null',
    '[object String]': 'String',
    '[object Number]': 'Number',
    '[object Boolean]': 'Boolean',
  }
  const valType = type[Object.prototype.toString.call(val)]
  return valType
}


/**
 * 检查是否为有效值
 * @param val
 * @returns {boolean}
 */
export const checkEffectVal = (val) => {
  const valType = valueType(val)
  if (valType === 'Object' && Object.keys(val).length === 0) {
    return false
  }

  if (valType === 'Array' && val.length === 0) {
    return false
  }

  if (val === null || val === undefined) {
    return false
  }

  if (valType === 'String') {
    if (val.trim() === '') {
      return false
    }
  }
  return true
}

//根据指定m保留小数点后m位
export const toFixed = (num, m) => {
  let number = num + ''
  if (number.split('.')[1] && number.split('.')[1].length > m) {
    return Math.trunc(Number(num) * Math.pow(10, m)) / Math.pow(10, m)
  } else {
    return num
  }
}

export const numberLimit = (e, m = 0, max) => {
  //非数字
  if (isNaN(Number(e))) {
    return undefined
  }
  //小于最小值
  if (e < 0) {
    return 0
  }
  //超过最大值
  if (max && e > max) {
    return max
  }
  return toFixed(e, m)
}


//加密前的JSON序列化
export const pars = (param, key) => {
  if (param == null) return '';
  var arr = [];
  var t = valueType(param);
  if (t == 'String' || t == 'Number' || t == 'Boolean' || t == '') {
    arr.push(key + '=' + param);
  } else if (t === 'Object') {
    if (Object.keys(param).length === 0) {
      if (key) {
        arr.push(`${key}=`)
      }
    }
    Object.keys(param).forEach((i, index) => {
      let k = key == null ? i : index === 0 ? key + '=' + i : i;
      arr.push(pars(param[i], k));
    })
  } else if (t === 'Array') {
    arr = param
    if (key) {
      arr[0] = `${key}=${checkEffectVal(arr[0]) ? arr[0] : ''}`
    }
  }
  return arr.join("&");
}
// 指定长度和基数
export const uuid = (len, radix) => {
  var chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('');
  var uuid = [],
    i;
  radix = radix || chars.length;

  if (len) {
    // Compact form
    for (i = 0; i < len; i++) uuid[i] = chars[0 | Math.random() * radix];
  } else {
    // rfc4122, version 4 form
    var r;

    // rfc4122 requires these characters
    uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-';
    uuid[14] = '4';

    // Fill in random data.  At i==19 set the high bits of clock sequence as
    // per rfc4122, sec. 4.1.5
    for (i = 0; i < 36; i++) {
      if (!uuid[i]) {
        r = 0 | Math.random() * 16;
        uuid[i] = chars[(i == 19) ? (r & 0x3) | 0x8 : r];
      }
    }
  }

  return uuid.join('');
}


/**
 *@params obj
 *@desc 对比对象 简单值的对比
 *@returns
 *@date 2020/4/10 11:50
 */
export const EqualObj = (target, orign) => {
  let flag = true
  Object.keys(target).forEach(key => {
    if (target[key] !== orign[key]) {
      flag = false
    }
  })

  return flag
}

//

export const addDateRange = (params, dateRange, propName) => {
  var search = params;
  search.dateRange = {};
  if (null != dateRange && '' != dateRange) {
    if (typeof (propName) === "undefined") {
      search.dateRange["beginTime"] = dateRange[0];
      search.dateRange["endTime"] = dateRange[1];
    } else {
      search.dateRange["begin" + propName] = dateRange[0];
      search.dateRange["end" + propName] = dateRange[1];
    }
  }
  if (Object.keys(search.dateRange).length === 0) delete search.dateRange
  return search;
}

export const addDateRange1 = (params, dateRange, propName) => {
  var search = JSON.parse(JSON.stringify(params));
  search.dateRange = {};
  if (null != dateRange && '' != dateRange) {
    if (typeof (propName) === "undefined") {
      search.updateTimeStart = dateRange[0];
      search.updateTimeEnd = dateRange[1];
    } else {
      search.dateRange["begin" + propName] = dateRange[0];
      search.dateRange["end" + propName] = dateRange[1];
    }
  }
  if (Object.keys(search.dateRange).length === 0) delete search.dateRange
  return search;
}

/**
 * 是否有权限
 * @param {*} key
 */
export function isAuth(key) {
  return JSON.parse(sessionStorage.getItem('permissions') || '[]').indexOf(key) !== -1 || false
}

/**
 * 树形数据转换
 * @param {*} data
 * @param {*} id
 * @param {*} pid
 */
export function treeDataTranslate(data, id = 'id', pid = 'pId') {
  var res = []
  var temp = {}
  for (var i = 0; i < data.length; i++) {
    temp[data[i][id]] = data[i]
  }
  for (var k = 0; k < data.length; k++) {
    if (temp[data[k][pid]] && data[k][id] !== data[k][pid]) {
      if (!temp[data[k][pid]]['children']) {
        temp[data[k][pid]]['children'] = []
      }
      if (!temp[data[k][pid]]['_level']) {
        temp[data[k][pid]]['_level'] = 1
      }
      data[k]['_level'] = temp[data[k][pid]]._level + 1
      temp[data[k][pid]]['children'].push(data[k])
    } else {
      res.push(data[k])
    }
  }
  return res
}

/**
 * 构造树型结构数据
 * @param {*} data 数据源
 * @param {*} id id字段 默认 'id'
 * @param {*} parentId 父节点字段 默认 'parentId'
 * @param {*} children 孩子节点字段 默认 'children'
 */
export function handleTree(data, id, parentId, children) {
  let config = {
    id: id || 'id',
    parentId: parentId || 'parentId',
    childrenList: children || 'children'
  };

  var childrenListMap = {};
  var nodeIds = {};
  var tree = [];

  for (let d of data) {
    let parentId = d[config.parentId];
    if (childrenListMap[parentId] == null) {
      childrenListMap[parentId] = [];
    }
    nodeIds[d[config.id]] = d;
    childrenListMap[parentId].push(d);
  }

  for (let d of data) {
    let parentId = d[config.parentId];
    if (nodeIds[parentId] == null) {
      tree.push(d);
    }
  }

  for (let t of tree) {
    adaptToChildrenList(t);
  }

  function adaptToChildrenList(o) {
    if (childrenListMap[o[config.id]] !== null) {
      o[config.childrenList] = childrenListMap[o[config.id]];
    }
    if (o[config.childrenList]) {
      for (let c of o[config.childrenList]) {
        adaptToChildrenList(c);
      }
    }
  }
  return tree;
}

// 日期格式化
export function parseTime(time, pattern) {
  if (arguments.length === 0 || !time) {
    return null
  }
  const format = pattern || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if ((typeof time === 'string') && (/^[0-9]+$/.test(time))) {
      time = parseInt(time)
    } else if (typeof time === 'string') {
      time = time.replace(new RegExp(/-/gm), '/');
    }
    if ((typeof time === 'number') && (time.toString().length === 10)) {
      time = time * 1000
    }
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key]
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') { return ['日', '一', '二', '三', '四', '五', '六'][value] }
    if (result.length > 0 && value < 10) {
      value = '0' + value
    }
    return value || 0
  })
  return time_str
}

// 回显数据字典
export function selectDictLabel(datas, value) {
  var actions = [];
  Object.keys(datas).some((key) => {
    if (datas[key].dictValue == ('' + value)) {
      actions.push(datas[key].dictLabel);
      return true;
    }
  })
  return actions.join('');
}

// 回显数据字典（字符串数组）
export const selectDictLabels = (datas, value, separator) => {
  var actions = [];
  var currentSeparator = undefined === separator ? "," : separator;
  var temp = value.split(currentSeparator);
  Object.keys(value.split(currentSeparator)).some((val) => {
    Object.keys(datas).some((key) => {
      if (datas[key].dictValue == ('' + temp[val])) {
        actions.push(datas[key].dictLabel + currentSeparator);
      }
    })
  })
  return actions.join('').substring(0, actions.join('').length - 1);
}

// 表单重置
export function resetForm(refName) {
  if (this.$refs[refName]) {
    this.$refs[refName].resetFields();
  }
}

// 通用下载方法
export function download(fileName) {
  window.location.href = baseURL + "/common/download?fileName=" + encodeURI(fileName) + "&delete=" + true;
}

export function converSize(limit) {
  var size = "";
  if (limit < 0.1 * 1024) { //如果小于0.1KB转化成B
    size = limit.toFixed(2) + "B";
  } else if (limit < 0.1 * 1024 * 1024) {//如果小于0.1MB转化成KB
    size = (limit / 1024).toFixed(2) + "K";
  } else if (limit < 0.1 * 1024 * 1024 * 1024) { //如果小于0.1GB转化成MB
    size = (limit / (1024 * 1024)).toFixed(2) + "M";
  } else { //其他转化成GB
    size = (limit / (1024 * 1024 * 1024)).toFixed(2) + "G";
  }

  var sizestr = size + "";
  var len = sizestr.indexOf(".");
  var dec = sizestr.substr(len + 1, 2);
  if (dec == "00") {//当小数点后为00时 去掉小数部分
    return sizestr.substring(0, len) + sizestr.substr(len + 3, 2);
  }
  return sizestr;
}

export function jumpTo(item) {
  if (item.targetType === 'JUMP_TYPE_FUNCTION_PAGE') {
    if (item.targetContent === 'retailOrder') {
      router.push('/data?tab=2')
      return
    }
    if (item.targetContent === 'myOrder') {
      router.push('/data?tab=1')
      return
    }
    router.push('/' + item.targetContent)
  } else if (item.targetType === 'JUMP_TYPE_H5') {
    // 根据域名前缀决定跳转方式
    const url = item.targetContent;
    const prefix = process.env.VUE_APP_URL;
    if (url.startsWith(prefix)) {
      // 提取基于应用路由的路径和查询字符串
      const pathAndQuery = url.slice(prefix.length) || '/';
      router.push(pathAndQuery);
    } else {
      window.location.href = url;
    }
  }
}
